module.exports = __webpack_public_path__ + "assets/img/9.764dd001.png";